import React from 'react';

interface SelectFieldProps {
    label?: string;
    name: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    options: { value: string; label: string }[];
    className?: string;
    disabled?: boolean;
}

const SelectField: React.FC<SelectFieldProps> = ({
    label,
    name,
    value,
    onChange,
    options,
    className = '',
    disabled = false,
}) => {
    return (
        <div className={`flex flex-col gap-1 ${className}`}>
            {label && (
                <label htmlFor={name} className="block text-xs font-normal mb-0.5 text-[#888888]">
                    {label}
                </label>
            )}
            <select
                id={name}
                name={name}
                value={value}
                onChange={onChange}
                disabled={disabled}
                className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-xs bg-white text-[#888888] focus:outline-none focus:ring-2 focus:ring-maxi-green"
            >
                {options.map(opt => (
                    <option key={opt.value} value={opt.value} className="text-[#888888]">{opt.label}</option>
                ))}
            </select>
        </div>
    );
};

export default SelectField;
